import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductService } from 'src/app/core/api/product/product.service';
import { UserService } from 'src/app/core/api/user/user.service';
import { RewardManagementService } from 'src/app/core/services/reward-management/reward-management.service';
import { CouponVip } from 'src/app/shared/models/dtos/responses/coupon-vip/coupon-vip';
import { Coupon } from 'src/app/shared/models/dtos/responses/coupon/coupon';

@Component({
  templateUrl: './product-coupon.page.html',
})
/**
 * Page that renders ProductCouponComponent template
 */
export class ProductCouponPage implements OnInit {
  coupon?: Coupon;
  couponVip?: CouponVip;

  /**
   * @constructor
   */
  constructor(
    private route: ActivatedRoute,
    private readonly rewardManagementService: RewardManagementService,
    private readonly userService: UserService,
    private readonly productService: ProductService
  ) {}

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    const route = this.route.routeConfig?.path;
    const couponId = this.route.snapshot.params['id'];
    if (route?.includes('coupons-vip')) {
      this.userService.getCouponVip(couponId).subscribe((coupon) => {
        this.productService.getBusinessEquipments().subscribe((models) => {
          coupon.printers = models;
          this.couponVip = coupon;
        });
      });
    } else {
      this.rewardManagementService.getCoupon(couponId).then((coupon) => {
        this.coupon = coupon;
      });
    }
  }

  /**
   * Builds coupon page title
   * @return {string}
   */
  getTitle(): string {
    if (this.couponVip) {
      return `${this.couponVip?.business.businessName} ${this.couponVip?.vipName}`;
    } else {
      return (
        this.coupon?.rewardName +
        (this.coupon?.productName ? ` - ${this.coupon?.productName}` : '')
      );
    }
  }
}
